import { ZoneKindSwatch } from '../../../../../shared/components/ZoneKindSwatch';
import type { KindCount } from '../policies/zones-map-data';

/** Which colour is which kind, for the zones on the map now. Deactivated zones are drawn grey whatever their kind. */
export function ZoneKindLegend({ counts }: { counts: KindCount[] }) {
  if (counts.length === 0) return null;
  return (
    <ul aria-label="Map legend" className="flex flex-wrap gap-x-4 gap-y-1.5 text-xs text-muted">
      {counts.map(({ kind, count }) => (
        <li key={kind.code} className="flex items-center gap-1.5">
          <ZoneKindSwatch color={kind.color} />
          <span className="text-fg">{kind.name}</span>
          <span>{count}</span>
        </li>
      ))}
    </ul>
  );
}
